<template>
  <navigate-detail :is-edit='true'>
  </navigate-detail>
</template>

<script>
import NavigateDetail from '../components/NavigateDetail'
export default {
  name: 'EditNavigate',
  components: {
    NavigateDetail
  }
}
</script>
